"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "SVBApiProducerHeader", {
  enumerable: true,
  get: function get() {
    return _SVBApiProducerHeader.default;
  }
});
var _SVBApiProducerHeader = _interopRequireDefault(require("./src/SVBApiProducerHeader"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }